import { gql, useQuery } from '@apollo/client';

const DPO_TASK_DOCUMENT_PREVIEW = gql`
  query GetDpoTaskDocumentPreview($taskId: String!, $companyId: String!) {
    getDpoTaskDocumentPreview(taskId: $taskId, companyId: $companyId)
  }
`;

export interface DpoTaskDocumentPreviewInput {
  taskId: string;
  companyId: string;
}

export interface DpoTaskDocumentPreviewResult {
  getDpoTaskDocumentPreview: string[];
}

export function useDpoTaskDocumentPreviewQuery(input: DpoTaskDocumentPreviewInput, skip?: boolean) {
  return useQuery<DpoTaskDocumentPreviewResult, DpoTaskDocumentPreviewInput>(DPO_TASK_DOCUMENT_PREVIEW, {
    variables: input,
    skip: skip || !input.taskId || !input.companyId,
  });
}
